/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { RoutingService } from 'src/app/service/routing.service';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/service/auth.service';
import { UserStateService } from 'src/app/shared/services/user-state.service';
import { ConfigService } from 'src/app/service/config.service';
import { ScorelabSetupComponent } from 'src/app/project/settings/scorelab-setup/scorelab-setup.component';
import { AlertsSetupComponent } from 'src/app/project/settings/alerts-setup/alerts-setup.component';
import { FlagsSetupComponent } from 'src/app/project/settings/flags-setup/flags-setup.component';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { FilterListService } from '../menu-filters/service/filter-list.service';

@Component({
  selector: 'app-menu-aside',
  templateUrl: './menu-aside.component.html',
  styleUrls: ['./menu-aside.component.scss'],
})
export class MenuAsideComponent implements OnInit {
  asidetxt: boolean;
  params: any;
  user: any = {
    id: '',
    email: '',
    account: 'customer',
    expire: '',
    roles: [],
    groups: [],
  };
  project: any;
  setup: any;
  // subscription: string;
  account: boolean;
  eventsList: any;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public routing: RoutingService,
    public location: Location,
    public auth: AuthService,
    public userState: UserStateService,
    private router: Router,
    public config: ConfigService,
    public snackBar: MatSnackBar,
    private filterListService: FilterListService,
  ) {
    this.project = this.config.appConfig.routing.project;
    this.setup = this.config.appConfig.setup;
    if (this.config.appConfig.setup.useStorage) {
      this.asidetxt = localStorage.getItem('aside') === 'true';
    }
    this.user = this.auth.authToken();
    // if (this.user) { this.subscription = this.user.subscription; }
    this.route.queryParams.subscribe((params) => {
      this.params = params;
    });
  }

  ngOnInit() {
    if (this.userState.eventsList) {
      this.eventsList = this.userState.eventsList;
    } else {
      this.filterListService.getEventList().subscribe((eventList) => {
        const eventListResult = JSON.parse(JSON.stringify(eventList));
        this.userState.eventsList = eventListResult;
        this.eventsList = this.userState.eventsList;
      });
    }
  }

  logOut() {
    this.auth.authLogout();
  }

  myAsidetxt() {
    this.asidetxt = !this.asidetxt;
    if (this.config.appConfig.setup.useStorage) {
      localStorage.setItem('aside', this.asidetxt.toString());
    }
  }

  /**
   * open mat-dialog for settings
   */
  openSettings() {
    this.dialog.open(ScorelabSetupComponent, {
      autoFocus: false,
    });
  }

  /**
   * open mat-dialog for alerts
   */
  openAlerts() {
    if (this.eventsList) {
      this.dialog.open(AlertsSetupComponent, {
        autoFocus: false,
      });
    }
  }

  /**
   * open mat-dialog for flags
   */
  openFlags() {
    this.dialog.open(FlagsSetupComponent, {
      autoFocus: false,
    });
  }
}
